import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';
const RecordedDataPage = () => {
  return (
    <>
    <div className="recorded-data-container">
            <Sidebar />
        <div className="main-content">
            <Header/>
            <RecordedDataComponent title="ARCHIVE INDEXED DATA" isClerk={true}/>
        </div>
    </div>
    </>
  )
}

export default RecordedDataPage